import { getDeliveryStatusLabel } from './status-labels';
import '@shared/styles/status-tag.css';

const DELIVERY_STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  draft: { bg: '#e5e7eb', color: '#374151' },
  planned: { bg: '#dbeafe', color: '#1e40af' },
  active: { bg: '#22d3ee', color: '#0e7490' },
  finished: { bg: '#22c55e', color: '#fff' },
  canceled: { bg: '#fecaca', color: '#991b1b' },
  delayed: { bg: '#fef3c7', color: '#92400e' },
  courier_assigned: { bg: '#e0e7ff', color: '#3730a3' },
  courier_departed: { bg: '#a5f3fc', color: '#0e7490' },
  courier_at_pickup: { bg: '#67e8f9', color: '#155e75' },
  parcel_picked_up: { bg: '#22d3ee', color: '#0e7490' },
  courier_arrived: { bg: '#86efac', color: '#166534' },
  deleted: { bg: '#9ca3af', color: '#1f2937' },
  return_courier_picked_up: { bg: '#fde68a', color: '#92400e' },
  return_finished: { bg: '#fecaca', color: '#991b1b' },
};

const DEFAULT_COLORS = { bg: '#e5e7eb', color: '#374151' };

const RETURN_COLORS = { bg: '#e9d5ff', color: '#6b21a8' };

interface DeliveryStatusTagProps {
  status: string | null | undefined;
  /** true, если точка доставки совпадает с первой (возврат на ПВЗ): при статусе «завершена» показываем «Возврат» */
  isReturnPoint?: boolean;
}

export default function DeliveryStatusTag({ status, isReturnPoint }: DeliveryStatusTagProps) {
  if (status == null || status === '') return <span>—</span>;
  const normalized = String(status).trim().toLowerCase();
  const isFinishedReturn = normalized === 'finished' && isReturnPoint === true;
  const label = isFinishedReturn ? 'Возврат' : getDeliveryStatusLabel(status);
  const { bg, color } = isFinishedReturn
    ? RETURN_COLORS
    : DELIVERY_STATUS_COLORS[normalized] ?? DEFAULT_COLORS;
  return (
    <span
      className="status-tag"
      style={{ backgroundColor: bg, color }}
    >
      {label}
    </span>
  );
}
